import { useQuery } from '@tanstack/react-query';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';

import shoppingContextService from 'services/shopping-context';

const queryKey = 'wtr-cr/shopping-context';

export const useShoppingContext = () => {
  const { state } = useAuthentication();

  const authHeader = state.token?.authHeader;

  const { data, isLoading } = useQuery({
    queryKey: [queryKey, authHeader],
    queryFn: () => shoppingContextService.getShoppingContext(authHeader!),
    enabled: !!authHeader,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return {
    data,
    isLoading,
  };
};
